

















import { Component, Prop, Vue } from 'vue-property-decorator';
import Booklet from "@/models/booklet";
import GoalBooklet from "@/models/goal-booklet";

@Component({
  components: {}
})
export default class BookletTile extends Vue {
  @Prop({
    default: null
  })
  public goalBooklet!: GoalBooklet;

  @Prop({
    default: true
  })
  public inDashboard!: boolean;

}
